import { isNumber } from "lodash";
import { EMPTY_PLACE, EMPTY_SEGMENT_TRANSFER_LOCATION } from "../../constant/transferConstant";
import { SegmentLocationType } from "../../objects/Segment";
import { OperationalOpenType, Transfer } from "../../objects/transfer";
import { Place } from "../../../place/objects/place";

const initTransferGeoLocation = (geo_location: Place, default_name?: string) => ({
    ...geo_location,
    address: geo_location.address ?? default_name ?? '',
    city_name: geo_location?.city_name ?? '',
    zip_code: geo_location?.zip_code ?? '',
    google_id: geo_location?.google_id ?? '',
    latitude: geo_location?.latitude ?? '48.8596169155',
    longitude: geo_location?.longitude ??  '2.3564089625'
});
export const transformTransfertBackendData = (transfer: Transfer | null): Transfer | null => transfer ? ({
    ...transfer,
    // operational_open_type: transfer.operational_open_type || OperationalOpenType.SPECIFIC_DAYS,
    segment: transfer.segment ? {
        ...transfer.segment,
        origin_location_type: transfer.segment.origin_location_type ?? SegmentLocationType.CITY_ZONE,
        destination_location_type: transfer.segment.destination_location_type ?? SegmentLocationType.CITY_ZONE,
        origin_transfer_location: transfer.segment.origin_transfer_location ?? EMPTY_SEGMENT_TRANSFER_LOCATION,
        destination_transfer_location: transfer.segment.destination_transfer_location ?? EMPTY_SEGMENT_TRANSFER_LOCATION,
        origin_geo_location: transfer.segment.origin_geo_location ? initTransferGeoLocation(transfer.segment.origin_geo_location, transfer.segment.origin_name) : { ...EMPTY_PLACE, address: transfer.segment.origin_name ?? '' },
        destination_geo_location: transfer.segment.destination_geo_location ? initTransferGeoLocation(transfer.segment.destination_geo_location, transfer.segment.destination_name) : { ...EMPTY_PLACE, address: transfer.segment.destination_name ?? '' },
        going_radius: transfer.segment.going_radius ? parseFloat(transfer.segment.going_radius as unknown as string) : 0,
        return_radius: transfer.segment.going_radius ? parseFloat(transfer.segment.return_radius as unknown as string) : 0,
        is_round_trip: transfer.segment.is_round_trip
    } : transfer.segment
}) : null;